import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/component`

export default {
  getComponentLookupOptions(componentType, name, start, count) {
    const queryParams = {
      name,
      start,
      count,
    }
    return ApiService.get(`${resourceUrl}/lookup/${componentType}`, {
      params: queryParams,
    })
  },
}
